import { Component, OnInit } from '@angular/core';

import { FileVm } from '../../../../shared/Models/fileVm';
import { Router } from '@angular/router';
import { uploadService } from './../../../../shared/uploadService';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { ElectronicSharingService } from '../../services/electronic-sharing.service';
import { switchMap } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import { ElectronicSharing } from '../../Models/electronic-sharing';
import { NbCardModule, NbButtonModule, NbInputModule, NbDialogModule, NbToastrModule } from '@nebular/theme';


@Component({
  selector: 'add-electronic-sharing',
  templateUrl: './add-electronic-sharing.component.html',
  styleUrls: ['./add-electronic-sharing.component.scss']
})
export class AddElectronicSharingComponent implements OnInit {
  isLoading: boolean = false;
  model = {} as ElectronicSharing;
  isEdit = false;
   validPhoto: boolean = true;
  previosusAttachments: FileVm[] = [];
  fileName: string[] = [];
  formData = new FormData();
  attachements: FormData;
  newPhotoUploaded = false;
  uploadThumbnail = false;
  constructor( private diagRef: NbDialogRef<AddElectronicSharingComponent>,
      private service: ElectronicSharingService,
      private uploadService: uploadService,
      private toast: NbToastrService,
      private route : Router) { }

  private async getMaxOrderIndex(): Promise<number> {
    const queryModel = {
      currentPage: 1,
      pageSize: 1000,
      sort: 'orderIndex',
      sortDirection: 'desc',
      searchTerm: ''
    };
    
    return new Promise((resolve) => {
      this.service.get(queryModel).subscribe(
        (res) => {
          if (res.result && res.result.length > 0) {
            const maxOrderIndex = Math.max(...res.result.map(item => item.orderIndex || 0));
            resolve(maxOrderIndex + 1);
          } else {
            resolve(1);
          }
        },
        () => {
          resolve(1);
        }
      );
    });
  }

 ngOnInit() {
    this.route.events.subscribe(() => {
      this.diagRef.close('false');
    });

    if (this.isEdit) {
      this.uploadService.updateFiles({ files: [], previousAttachments: this.model.attachements });
    } else {
      this.model.descriptionAR = '';
      this.model.descriptionEN = '';
      this.model.description2AR = '';
      this.model.description2EN = '';
      this.model.link = ''
      this.model.isExternallink = false;
      this.model.isIconEnabled = false;
      this.model.isVertical = false;
      this.attachements = new FormData();
      this.uploadThumbnail = true;
      this.validPhoto = false;
      this.uploadService.updateFiles({ files: [], previousAttachments: [] });
      
      
      this.getMaxOrderIndex().then((orderIndex) => {
        this.model.orderIndex = orderIndex;
      });
    }
  }

  removePhoot() {
    this.formData = new FormData();
    this.uploadThumbnail = true;
    this.validPhoto = false;
  }
  updateElectronicSharing() {
    this.isLoading = true;

    const imgUpload$ = this.newPhotoUploaded
      ? this.uploadService.uploadImage(this.formData)
      : this.uploadService.uploadImage(this.model.thumbnail);
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([imgUpload$, attachments$])
      .pipe(
        switchMap(([img, files]) => {
          this.model.thumbnail = img;
          this.model.attachements = files;
         
          const { tabs, ...modelWithoutTabs } = this.model as any;
          return this.service.put(this.model.id, modelWithoutTabs);
        })
      )
      .subscribe(
        () => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم تعديل المشاركة الإلكترونية بنجاح', '', { status: 'success', duration: 3000 });
        },
        (error) => {
          this.isLoading = false;
          console.error('Error while updating:', error);
          this.toast.show('حدث خطأ أثناء تعديل المشاركة الإلكترونية', '', { status: 'danger', duration: 3000 });
        }
      );
  }
  save() {
    this.isLoading = true;

    const imgUpload$ = this.uploadService.uploadImage(this.formData);
    const attachments$ = this.uploadService.uploadMultipleFiles();

    combineLatest([imgUpload$, attachments$])
      .pipe(
        switchMap(([img, files]) => {
          this.model.thumbnail = img;
          this.model.attachements = files;
          return this.service.post(this.model);
        })
      )
      .subscribe(
        () => {
          this.isLoading = false;
          this.diagRef.close('true');
          this.toast.show('تم إضافة مشاركة إلكترونية جديدة بنجاح', '', { status: 'success', duration: 3000 });
        },
        (error) => {
          this.isLoading = false;
          console.error('Error while saving:', error);
          this.toast.show('حدث خطأ أثناء إضافة المشاركة الإلكترونية', '', { status: 'danger', duration: 3000 });
        }
      );
  }
    getFormData(event) {
    
    if (event) {
      this.formData = event;
      this.validPhoto = true;
      this.newPhotoUploaded = true;
    } else {
      this.formData = new FormData();
      this.validPhoto = false;
      this.newPhotoUploaded = false;
    }

  }

  uploadFile(event) {
    this.uploadService.updateFiles({ files: event, previousAttachments: this.model.attachements });
  }


  close() {
    this.diagRef.close();
  }
}
